import { render, staticRenderFns } from "./BranchAdd.vue?vue&type=template&id=bd5abc26&scoped=true&"
import script from "./BranchAdd.vue?vue&type=script&lang=js&"
export * from "./BranchAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5abc26",
  null
  
)

export default component.exports